import querystring from 'querystring';
import query from '@zillow/parsed-query';

var getHashParams = function getHashParams() {
  var hashparams = {};

  if (typeof window !== 'undefined' && window.location && window.location.hash) {
    var trimmedHash = window.location.hash && decodeURIComponent(window.location.hash.replace(/[#/*]/g, ''));
    hashparams = querystring.parse(trimmedHash);
  }

  return hashparams;
};

var PLATFORM_QUERY = 'appPlatform'; // One of ['android', 'ios']
// Might use device class later
// const DEVICE_CLASS_QUERY = 'appDeviceClass'; // One of ['tablet', 'phone']

var getPlatform = function getPlatform() {
  var platform = typeof window !== 'undefined' && window.ZMOB_data && typeof window.ZMOB_data.getAppPlatform === 'function' && window.ZMOB_data.getAppPlatform();
  return platform || query[PLATFORM_QUERY] || getHashParams()[PLATFORM_QUERY];
}; // export const getDeviceClass = () => query[DEVICE_CLASS_QUERY];

var isWebview = function isWebview() {
  return !!getPlatform();
};

var platformContains = function platformContains(key) {
  var platform = getPlatform();

  if (!platform) {
    return null;
  }

  return platform.indexOf(key) >= 0;
};

var isIos = function isIos() {
  return platformContains('ios');
};
var isAndroid = function isAndroid() {
  return platformContains('android');
};
var getPartnerId = function getPartnerId() {
  if (isIos()) {
    return 'RD-GYRDDFT'; // ZillowMap iPhone
  }

  if (isAndroid()) {
    return 'RD-MVRWMMN'; // ZillowMap Android
  }

  return null;
};

export { getPartnerId, getPlatform, isAndroid, isIos, isWebview };
